var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M32.5607 6.43934C33.1464 7.02513 33.1464 7.97487 32.5607 8.56066L14.5607 26.5607C13.9749 27.1464 13.0251 27.1464 12.4393 26.5607L3.43934 17.5607C2.85355 16.9749 2.85355 16.0251 3.43934 15.4393C4.02513 14.8536 4.97487 14.8536 5.56066 15.4393L13.5 23.3787L30.4393 6.43934C31.0251 5.85355 31.9749 5.85355 32.5607 6.43934Z","fill":"#153E67"}));
}

Check.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Check;

Check.default = Check;
